import config from '../config';
import { clampTextToDimensions } from '../utils';

const SLIDER_ON = 'slider-on.png';
const SLIDER_OFF = 'slider-off.png';

let soundManager;
let dataManager;
class Settings extends Phaser.Scene {
  init () {
    // console.log('Settings.init');
    let g = this;

    soundManager = g.scene.get('SoundManager');
    soundManager.pauseMusic();

    dataManager = g.sys.game.dataManager;

    g.scene.pause(dataManager.getSessionItem(config.BASE_SCENE));
  }
  create () {
    // console.log('Settings.create');
    let g = this;

    // let lastMapKey = dataManager.getSessionItem('lastMapKey');
    // console.log('lastMapKey', lastMapKey);

    let group = [];

    let bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay-bg');
    bg.setAlpha(0);

    let panelX = -config.WIDTH / 2;

    let panel = g.add.sprite(panelX, config.CENTER_Y + 150, 'settings-sprite');
    panel.setFrame('window.png');
    group.push(panel);

    // let body = g.add.sprite(panelX + 25, panel.y - 340, 'settings-sprite');
    // body.setFrame('bumble-body.png');
    // group.push(body);

    let bb = g.add.sprite(panelX, panel.y - 336, 'settings-bb', 'body/body_00.png');
    group.push(bb);
    let arm = g.add.sprite(bb.x, bb.y, 'settings-bb');
    group.push(arm);
    g.children.bringToTop(bb);
    let eyes = g.add.sprite(bb.x, bb.y, 'settings-bb');
    eyes.play('settings-eyes');
    group.push(eyes);
    let foot = g.add.sprite(bb.x, bb.y, 'settings-bb');
    foot.play('settings-foot');
    group.push(foot);

    function armPlay () {
      arm.play('settings-arm-up');
      arm.once('animationcomplete', () => {
        arm.play('settings-finger-wiggle');
        arm.once('animationcomplete', () => {
          arm.play('settings-arm-down');
          arm.once('animationcomplete', () => {
            arm.play('settings-finger-pick');
            arm.once('animationcomplete', () => {
              g.time.delayedCall(1000, () => {
                armPlay();
              });
            });
          });
        });
      });
    }
    armPlay();

    let xBtn = g.add.sprite(panelX, panel.y + 225, 'settings-sprite');
    xBtn.setFrame('btn-x.png');
    group.push(xBtn);

    let titleText = g.add.text(panelX, panel.y - 550, g.game.localisationManager.GetString("paused"), { fontFamily: "FredBurger Black", fontSize: (65) +"px", color: "#FFF", align: 'center' })
    titleText.setOrigin(0.5);
    titleText.setStroke('#000', 16);
    
    group.push(titleText);
    
    if (dataManager.getSessionItem(config.BASE_SCENE) === 'Play') {
      titleText.setText(g.game.localisationManager.GetString("paused"));
    } else {
      titleText.setText(g.game.localisationManager.GetString("settings"));
    }
    
    clampTextToDimensions(titleText, g.scale.width, 200);

    let musicOn = dataManager.getItem(config.MUSIC_ON);
    let soundsOn = dataManager.getItem(config.SOUNDS_ON);

    let mSlider = g.add.sprite(panelX + 25, panel.y - 50, 'settings-sprite');
    group.push(mSlider);
    mSlider.setFrame(musicOn ? SLIDER_ON : SLIDER_OFF);
    mSlider.setOrigin(0, 0.5);
    
    let mText = g.add.text(panelX - 100, mSlider.y, g.game.localisationManager.GetString("music"), { fontFamily: "FredBurger Black", fontSize: (40) +"px", color: "#000", align: 'center' })
    mText.setOrigin(0.5);
    clampTextToDimensions(mText, 220, 200);
    group.push(mText);

    let sSlider = g.add.sprite(panelX + 25, panel.y + 55, 'settings-sprite');
    group.push(sSlider);
    sSlider.setFrame(soundsOn ? SLIDER_ON : SLIDER_OFF);
    sSlider.setOrigin(0, 0.5);
    
    let sText = g.add.text(mText.x, sSlider.y, g.game.localisationManager.GetString("sfx"), { fontFamily: "FredBurger Black", fontSize: (40) +"px", color: "#000", align: 'center' })
    sText.setOrigin(0.5);
    clampTextToDimensions(sText, 220, 200);
    group.push(sText);

    let version = g.add.text(panelX + 204, panel.y + 204, 'v ' + g.sys.game.gameConfig.version, { fontFamily: "FredBurger Black", fontSize: (24) +"px", color: "#000", align: 'center' });
    version.setOrigin(1, 0.5);
    group.push(version);

    mSlider.setInteractive();
    mSlider.on('pointerdown', () => {
      // console.log('mSlider clicked', mSlider.frame.name);
      musicOn = !musicOn;
      dataManager.setItem(config.MUSIC_ON, musicOn);
      mSlider.setFrame(mSlider.frame.name === SLIDER_ON ? SLIDER_OFF : SLIDER_ON);
    });
    sSlider.setInteractive();
    sSlider.on('pointerdown', () => {
      // console.log('sSlider clicked');
      soundsOn = !soundsOn;
      dataManager.setItem(config.SOUNDS_ON, soundsOn);
      sSlider.setFrame(sSlider.frame.name === SLIDER_ON ? SLIDER_OFF : SLIDER_ON);
    });
    xBtn.setInteractive();
    xBtn.once('pointerdown', () => {
      g.tweens.add({
        targets: bg,
        alpha: 0,
        duration: 250
      });
      g.tweens.add({
        targets: group,
        x: '+=' + config.WIDTH,
        duration: 250,
        ease: 'Quad.easeOut',
        onComplete: () => {
          g.scene.stop('Settings');
          g.scene.resume(dataManager.getSessionItem(config.BASE_SCENE));
        }
      });
    });
    g.tweens.add({
      targets: bg,
      alpha: 0.9,
      duration: 250
    });
    g.tweens.add({
      targets: group,
      x: '+=' + config.WIDTH,
      duration: 500,
      ease: 'Back.easeOut'
    });
  }
}

export default Settings;
